export default "__VITE_ASSET__8f26dadd__"